module.exports = __webpack_public_path__ + "media/assets/fonts/Gobold-Regular-80684b39192382f4dd0ae43074ad4e31.otf";